import "./QRCodePopup.css";
import xyz from "../../assets/QR.avif";

export default function QRCodePopup({ qrImage, onClose }) {
  const qrBase = "https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=";
  const qrSrc = `${qrBase}${encodeURIComponent(qrImage)}`;

  return (
    <div className="qr-overlay" onClick={onClose}>
      <div className="qr-popup" onClick={(e) => e.stopPropagation()}>
        <button className="qr-close" onClick={onClose}>
          ✖
        </button>
        <img src={`${qrSrc}`} alt="QR Code" className="qr-image" />
      </div>
    </div>
  );
}
